/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const updateChallengeTitleV1BodySchema = z.object({
  title: z.string().min(1),
});

export type IUpdateChallengeTitleV1Body = z.infer<typeof updateChallengeTitleV1BodySchema>;

export interface IUpdateChallengeTitleV1Request {
  id: number;
  body: IUpdateChallengeTitleV1Body;
}
